import { Component, OnInit, Input, input } from '@angular/core';

import { Image } from '@frontend/core';

@Component({
  selector: 'frontend-quotation-type-one',
  templateUrl: './quotation-type-one.component.html',
  styleUrls: ['./quotation-type-one.component.scss'],

  standalone: false,
})
export class QuotationTypeOneComponent implements OnInit {

  image = input<Image>();
  @Input() originator : string;
  @Input() originator_description : string;
  @Input() quotationText : string;
  @Input() source : string;

  constructor() { }

  ngOnInit(): void {
  }

}
